<template>
  <div id="page">
    <van-nav-bar
        title="活动详情"
        left-text=""
        left-arrow
        @click-left="onClickLeft()"
      />
    <img src="../assets/team1/activity.jpg" fit="contain" width="100%" alt="" />
  </div>
</template>

<script>
import { NavBar } from "vant";
export default {
  name: "activity",
  data() {
    return {
    };
  },
  components: {
    [NavBar.name]: NavBar,
  },
  mounted() {
  },
  methods: {
    onClickLeft() {
      this.$router.back(-1);
    },
  },
};


</script>